import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog } from '@angular/material/dialog';
import { ListaMarcas } from '../model/ListaArticulos';
import { ArticulosWebService } from '../service/articulos-web.service';
import { DialogAddComponent } from '../dialog-add/dialog-add.component';


@Component({
  templateUrl: './marcas.component.html',
  styleUrls: ['./marcas.component.scss']
})
export class MarcasComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
              private snackBar: MatSnackBar,
              private service: ArticulosWebService,
  ) { }
  displayedColumns: string[] = [
    'select',
    'MarcaID',
    'Descripcion',
    'Quien',
    'Cuando',
    'Estado'
  ];

  dataSource: MatTableDataSource<ListaMarcas>;
  selection: SelectionModel<ListaMarcas>;
  public listMarcas: ListaMarcas[] = [];
  public loadRefrech: boolean;
  public loadUpdate: boolean;
  public loadDelete: boolean;

  ngOnInit() {
    this.service.getListMarcas().subscribe(data => {
      this.dataSource = new MatTableDataSource(data);
      this.selection = new SelectionModel<ListaMarcas>(true, []);
    });
  }

  public updateAll(): void {
    this.loadUpdate = true;
    const mensaje = this.listMarcas.length > 1 ? 'Las marcas se actualizarón correctamente' : 'La marca se actualizo correctamente';
    this.service.updateMarcas(this.listMarcas).subscribe(res => {
      if (res.estatus) {
        this.openSnackBar(mensaje);
        this.refreshClaves();
      }
      this.loadUpdate = false;
    });
  }

  public deleteListArticles(): void {
    this.loadDelete = true;
    const mensaje = this.listMarcas.length > 1 ? 'Las marcas se eliminaron correctamente' : 'La marca se elimino correctamente';
    this.service.deleteMarcas(this.listMarcas).subscribe(res => {
      if (res.estatus) {
        this.openSnackBar(mensaje);
        this.refreshClaves();
      }
      this.loadDelete = false;
    });
  }
  public refreshClaves(): void {
    this.loadRefrech = true;
    this.service.getListMarcas().subscribe(data => {
      this.dataSource.data = data;
      this.selection = new SelectionModel<ListaMarcas>(true, []);
      this.loadRefrech = false;
      this.listMarcas = [];
    });
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  public selected(event?: any, row?: ListaMarcas) {
    if (event.checked) {
      this.listMarcas = [...this.listMarcas, row];
    } else {
      this.removeToArray(row);
    }
    event = event ? this.selection.toggle(row) : null;
    return event;
  }

  private removeToArray(row: ListaMarcas): void {
    let contador = 0;
    this.listMarcas.forEach(articulos => {
      if (articulos.Id === row.Id) {
        // console.log(this.listArticulos.length);
        if (this.listMarcas.length <= 1) {
          this.listMarcas = [];
        } else {
          const cont = contador <= 1 ? 1 : contador;
          this.listMarcas.splice(contador, 1);
        }
      }
      contador++;
    });
  }
  masterToggle() {
    this.listMarcas = [];
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => {
        this.listMarcas = [...this.listMarcas, row];
        this.selection.select(row);
      });
  }

  openSnackBar(mensaje: string) {
    this.snackBar.open(mensaje, 'Ok', {
      duration: 2200,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
    });
  }


  checkboxLabel(row?: ListaMarcas): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.Id + 1}`;
  }
  public openDialogAddNew(): void {
    const dialogRef = this.dialog.open(DialogAddComponent, {
      disableClose: true,
      data: { opcion: 3 },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.openSnackBar('La marca se agrego correctamente');
        this.refreshClaves();
      }
    });
  }
}
